export class FeedbackDetails {
  comments: string = '';
  appointAgent: string = '';
  appointAgentTextQuestion: string | null = null;
  startProcess: string = '';
  currentClient: boolean | null = null;
  clientReferenceNumber: string | null = null;
}
